import * as Styled from './ListInline.styled';

import { type ListInlineProps } from './ListInline.typed';

const ListInline = (props: ListInlineProps) => {
  const {
    children,
    separator,
    as = 'ul',
    fontSize = 'M16',
    separatorColour = 'GREY_DARK',
    keyName,
  } = props;

  const items = Array.isArray(children) ? children : [children];

  return (
    <Styled.ListInline as={as}>
      {items.map((child, index) => {
        if (child) {
          return (
            <Styled.ListItem
              key={`${keyName}${index}`}
              separator={separator}
              separatorColour={separatorColour}
              fontSize={fontSize}
            >
              {child}
            </Styled.ListItem>
          );
        }
      })}
    </Styled.ListInline>
  );
};
export { ListInline };
